var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { pairScreen } from '../../api/screenPairing';
import { useErrorHandler } from '../../hooks/useErrorHandler';
import { formatCode, getPairErrorMessage } from './utils';
// Known API errors (expired code, validation) are returned for inline display, the rest go to the global alert
export const usePairScreen = () => {
    const { errorHandler, setSuccess } = useErrorHandler();
    return (code, eventId) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const screen = yield pairScreen({ code, eventId: eventId || undefined });
            setSuccess(`Экран ${formatCode(code)} подключён`);
            return { screen, error: null };
        }
        catch (e) {
            const message = getPairErrorMessage(e);
            if (!message)
                errorHandler(e);
            return { screen: null, error: message || 'Не удалось подключить экран' };
        }
    });
};
